var _circle, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _rect, _path8, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreaseIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 112,
    viewBox: "0 0 121 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 56,
    r: 56,
    fill: "#F6F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8111 21L93.4561 29.7761H95.2718V90.6033H104.653V29.7761H106.166L99.8111 21Z",
    fill: "#A685EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3516 90.6034V40.3301H90.7329V90.6034H81.3516Z",
    fill: "#A685EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6411 90.6038V54.2891H76.5093V90.6038H68.6411Z",
    fill: "#6DE0A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9312 90.6025V46.666H63.7993V90.6025H55.9312Z",
    fill: "#6DE0A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2207 90.6035V63.9727H51.0889V90.6035H43.2207Z",
    fill: "#FBD07E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5107 90.6036V74.8672H38.3789V90.6036H30.5107Z",
    fill: "#FBD07E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1351_27271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.25 94.4992V71.0882C54.25 69.7996 55.2947 68.7549 56.5833 68.7549H93.9167C95.2053 68.7549 96.25 69.7996 96.25 71.0882V94.4992C96.25 95.7879 95.2053 96.8325 93.9167 96.8325H56.5833C55.2947 96.8325 54.25 95.7879 54.25 94.4992Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2915 73.791L75.2499 83.416L91.2081 73.791",
    stroke: "#2F3139",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.5835,
    y: 79.916,
    width: 9.33333,
    height: 4.08333,
    rx: 1.48815,
    fill: "#6DE0A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68.7552V65.0712C82 64.2493 81.3337 63.583 80.5119 63.583H69.9881C69.1663 63.583 68.5 64.2493 68.5 65.0712V68.7552",
    stroke: "#2F3139"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1351_27271)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.1665,
    y: 8.75,
    width: 37.3333,
    height: 28,
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0506 30.0754C57.864 31.5068 60.1438 32.2147 62.449 32.0624C64.7542 31.91 66.9209 30.9081 68.5301 29.2505C70.1393 27.5929 71.0765 25.3974 71.1605 23.0887C71.2445 20.78 70.4693 18.5222 68.9848 16.752L66.1242 19.151C67.0149 20.213 67.48 21.5677 67.4296 22.9529C67.3792 24.3382 66.8169 25.6555 65.8514 26.65C64.8859 27.6446 63.5858 28.2457 62.2027 28.3372C60.8196 28.4286 59.4517 28.0038 58.3637 27.145L56.0506 30.0754Z",
    fill: "#A685EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.433 16.1497C66.6827 14.3993 64.3087 13.416 61.8333 13.416V17.1493C63.3185 17.1493 64.7429 17.7393 65.7931 18.7896L68.433 16.1497Z",
    fill: "#6DE0A9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7428 13.4799C59.3052 13.6491 57.9267 14.1503 56.7161 14.9439C55.5056 15.7375 54.4962 16.8018 53.7678 18.0527L56.994 19.9314C57.4311 19.1808 58.0367 18.5423 58.763 18.0661C59.4893 17.5899 60.3165 17.2892 61.179 17.1877L60.7428 13.4799Z",
    fill: "#FBD07E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1889 19.2301C52.5067 20.9059 52.3262 22.7438 52.6696 24.5203C53.0129 26.2968 53.8652 27.9352 55.1227 29.2362L57.807 26.6414C57.0524 25.8609 56.5411 24.8778 56.3351 23.8119C56.1291 22.746 56.2373 21.6433 56.6467 20.6378L53.1889 19.2301Z",
    fill: "#FBD07E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 55.3602C37.3333 65.6384 18.6667 86.9167 18.6667 86.9167C18.6667 86.9167 0 65.6384 0 55.3602C0 45.0821 8.35735 36.75 18.6667 36.75C28.976 36.75 37.3333 45.0821 37.3333 55.3602Z",
    fill: "#6DE0A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.083 54.9167L18.6663 47.25L26.2497 54.9167H23.9747V60.6667H13.358V54.9167H11.083Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1351_27271",
    x: 48.25,
    y: 65.7549,
    width: 54,
    height: 40.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101597 0 0 0 0 0.190206 0 0 0 0 0.316667 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27271"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27271",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1351_27271",
    x: 37.1665,
    y: 5.75,
    width: 49.3335,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101597 0 0 0 0 0.190206 0 0 0 0 0.316667 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1351_27271"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1351_27271",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon2);
export default __webpack_public_path__ + "static/media/increaseIcon2.f6c9f4102cec08b8aba910035c74f2b3.svg";
export { ForwardRef as ReactComponent };